.page {
  font-family: freight-text-pro; /* TODO: Freight (400) */
  padding: var(--mantine-spacing-md);
  font-size: 16px;
  margin: auto;
}

.container {
  background-color: #ede5de !important;
}

@media only screen and (min-width: 576px) and (max-width: 768px) {
  .page {
    width: 80%;
  }
}

@media only screen and (min-width: 120px) and (max-width: 576px) {
  .page {
    width: 100%;
  }
}

@media only screen and (max-width: 246px) {
  .page {
    padding: 6px;
  }
}

.title {
  font-family: freight-text-pro;
  font-style: italic;
  font-size: 30px;
}

.section {
  padding-top: 32px;
}

.sectionHeader {
  font-family: pragmatica; /* TODO: Pragmatica (300) */
  text-decoration: underline;
  text-transform: uppercase;
  font-size: 17px;
  line-height: 22px;
  font-weight: 300;
  padding-bottom: 12px;
  letter-spacing: 0.07em;
}

.component {
  display: flex;
  flex-direction: row;
  padding-bottom: 16px;
}

.paragraph {
  margin-bottom: 16px;
  font-family: freight-text-pro-regular;
  letter-spacing: normal;
}

.footer p {
  font-size: 16px;
  font-family: freight-text-pro-regular;
}

.dropdown {
  margin-bottom: 24px;
}

.dropdownInput {
  display: flex;
  justify-content: space-between;
  padding: 6px 8px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  cursor: pointer;
  z-index: 10;
}
.m_8fb7ebe7 {
  background-color: #a39f9f;
}

.Select-module__941erG__input {
  background-color: #a39f9f;
}

.dropdownInput:hover,
.dropdownInput:active,
.dropdownItem:hover,
.dropdownItem:active {
  background-color: #a39f9f;
}

.dropdownContent {
  margin-top: -1px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  height: auto;
  z-index: 1;
}

.dropdownItem {
  padding: 6px 8px;
  cursor: pointer;
}

.dropdownContentClosed {
  display: none;
}

.operation {
  display: grid;
  padding: 8px 12px;
  grid-gap: 10px;
  justify-content: left;
  position: relative;
  min-height: 70px;
}

.triman {
  margin: auto;
  display: block;
}
